/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';
import { sizeChoices } from '../helpers';

import Types from '../../../modules/types';

const {
  CONTENT_BUILDER_EFFECT: { TYPE_MAP: CBEF_MAP },
} = Types;

const isNotShadow = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'SHADOW',
]);

const isNotShadowSizeCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'shadow_size',
  '!==',
  'CUSTOM',
]);

const ITEM_FIELDS = Admin.compileFromLibrary([
  ['FieldRadio', {
    name: 'shadow_type',
    label: null,
    initialValue: 'NORMAL',
    choices: ['Normal', 'Inset'].map(label => ({
      label,
      value: label.toUpperCase(),
    })),
    block: true,
  }],
  ['FieldRadio', {
    label: null,
    name: 'shadow_size',
    initialValue: 'MEDIUM',
    choices: [
      ...sizeChoices,
      {
        label: 'Custom',
        value: 'CUSTOM',
      },
    ],
    block: true,
  }],
  getFilterWithCol(['FieldText', {
    label: null,
    prefix: 'X:',
    name: 'shadow_custom.x',
    skip: [isNotShadowSizeCustom],
  }], 6),
  getFilterWithCol(['FieldText', {
    label: null,
    prefix: 'Y:',
    name: 'shadow_custom.y',
    skip: [isNotShadowSizeCustom],
  }], 6),
  getFilterWithCol(['FieldText', {
    label: null,
    prefix: 'Blur:',
    name: 'shadow_custom.blur',
    skip: [isNotShadowSizeCustom],
  }], 6),
  getFilterWithCol(['FieldText', {
    label: null,
    prefix: 'Spread:',
    name: 'shadow_custom.spread',
    skip: [isNotShadowSizeCustom],
  }], 6),
  getFilterWithCol(['FieldColorPicker', {
    label: null,
    prefix: 'Color:',
    name: 'shadow_custom.color',
    useAlpha: true,
    skip: [isNotShadowSizeCustom],
  }], 24),
], true);

Admin.addToLibrary(
  'FieldContentBuilderEffects:SHADOW:ITEM',
  (config = {}) => Admin.compileFromLibrary(['FieldContentBuilderNodes', {
    name: 'shadow_items',
    preSkip: [isNotShadow],
    addButtonLabel: 'Add Shadow',
    pasteButtonLabel: 'Paste Shadow',
    toolbarProps: {
      itemsLabelsMap: { '*': 'Shadow Layer' },
    },
    copyRealm: 'ContentBuilder:Effect:SHADOW:shadow_items:*',
    pasteRealm: 'ContentBuilder:Effect:SHADOW:shadow_items:*',
    targetable: false,
    fields: [
      ...ITEM_FIELDS,
    ],
    nodeType: CBEF_MAP.SHADOW.children.shadow_items.node,
    ...config,
  }]),
);

export default [
  ...[

  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotShadow, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderEffects:SHADOW:ITEM', {
    name: 'shadow_items',
  }],
];
